import BookCollections from "../components/ListLayout";
import BookForm from "../components/BookForm";

export default function Home() {
  return (
    <div>
      <main class="py-12 2xl:px-6">
        <div class="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
          <BookCollections />
          <BookForm />
        </div>
      </main>
    </div>
  );
}
